/* src/app/components/payroll/purchase-request/create-purchase-request/create-purchase-request.component.css */
.purchase-request-create-dialog {
  background: #fff;
  margin: 10px;
  border-radius: 5px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.flex-container {
  display: flex;
  gap: 10px;
  align-items: center;
}
.flex-container .participant-id-flex-item {
  width: 100%;
  flex: 0 0 70%;
}
.flex-container .get-participant-flex-item {
  flex: 0 0 20%;
}
.flex-container .get-participant-flex-item .primary-button {
  justify-content: center;
}
.form-required-field {
  color: #ff0000;
}
.grand-total {
  width: 100%;
}
.shipping-address {
  width: 100%;
}
.consumer-view-button-row {
  justify-content: left;
}
.staff-view-button-row {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
}
.button-container {
  display: flex;
  gap: 8px;
}
::ng-deep ppl-create-purchase-request .ant-divider.divider.ant-divider-horizontal {
  margin: 12px 0;
}
::ng-deep ppl-address nz-form-item {
  width: 100%;
}
::ng-deep ppl-address > div {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
::ng-deep ppl-address nz-form-item {
  flex: 1 1 calc(33.33% - 16px);
  min-width: 260px;
}
::ng-deep ppl-address .ant-form-item-label {
  width: 100%;
}
::ng-deep ppl-address .ant-form-item-control {
  width: 100%;
}
::ng-deep ppl-address .address-bar nz-select {
  width: 100%;
}
::ng-deep .limit-dialog-width .medium .body {
  padding-bottom: 12px;
}
::ng-deep nz-input-group .ant-input-wrapper.ant-input-group {
  margin-bottom: 0;
}
::ng-deep nz-input-group .ant-input-wrapper.ant-input-group .ant-input-group-addon {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  font-weight: bold;
}
::ng-deep ppl-upload ul li.file-details {
  display: flex;
}
.close-icon {
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}
.hyperlink {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}
.success-status {
  color: blue;
  font-weight: bold;
}
tbody.purchase-request-entries tr td {
  text-align: left;
  vertical-align: middle;
}
/*# sourceMappingURL=create-purchase-request.component-5HNNXUE6.css.map */
